import { request } from './http';
import { invalidateReadCache } from './readCache';

export async function getUsers(options = {}) {
    const params = new URLSearchParams();
    if (options.includeInactive) params.set('includeInactive', '1');
    const qs = params.toString();
    return request(`/users${qs ? `?${qs}` : ''}`);
  }

export async function getUserAccessOverview(userId, options = {}) {
    const params = new URLSearchParams();
    if (options.includeCompleted) params.set('includeCompleted', '1');
    const qs = params.toString();
    return request(`/users/${userId}/access-overview${qs ? `?${qs}` : ''}`);
  }

export async function getUserAccessMatrix(companyId) {
    const params = new URLSearchParams({ companyId: String(companyId) });
    return request(`/users/access/matrix?${params.toString()}`);
  }

export async function previewUserAccessChange(payload) {
    return request('/users/access/preview', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function applyUserAccessChange(payload) {
    return request('/users/access/apply', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function getUserAccessFormTypes({ companyId, siteIds } = {}) {
    const params = new URLSearchParams();
    if (companyId) params.set('companyId', String(companyId));
    if (siteIds?.length) params.set('siteIds', siteIds.join(','));
    return request(`/users/access/form-types?${params.toString()}`);
  }

export async function getUserAccessAssignable({ companyId, userId, userIds, raciRole, siteIds } = {}) {
    const params = new URLSearchParams();
    if (companyId) params.set('companyId', String(companyId));
    const ids = [...new Set([
      ...(Array.isArray(userIds) ? userIds : []),
      ...(userId ? [userId] : [])
    ].map((id) => String(id).trim()).filter(Boolean))];
    if (ids.length === 1) params.set('userId', ids[0]);
    if (ids.length > 0) params.set('userIds', ids.join(','));
    if (raciRole) params.set('raciRole', String(raciRole));
    if (siteIds?.length) params.set('siteIds', siteIds.join(','));
    return request(`/users/access/assignable?${params.toString()}`);
  }

export async function getUserAccessHistory(userId) {
    return request(`/users/${userId}/access-history`);
  }

export async function getUserRecordActivity(userId) {
    return request(`/users/${userId}/record-activity`);
  }

export async function sendUserPasswordReset(userId) {
    return request(`/users/${userId}/send-password-reset`, {
      method: 'POST'
    });
  }

export async function getUserById(id) {
    return request(`/users/${id}`);
  }

export async function createUser(userData) {
  const result = await request('/users', {
    method: 'POST',
    body: JSON.stringify(userData),
  });
  invalidateReadCache('profile');
  return result;
}

export async function updateUser(id, userData) {
  const result = await request(`/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(userData),
  });
  invalidateReadCache('profile');
  return result;
}

export async function deleteUser(id) {
  const result = await request(`/users/${id}`, {
    method: 'DELETE',
  });
  invalidateReadCache('profile');
  return result;
}

export async function getAllRoles() {
    return request('/users/roles/all');
  }

export async function getUserRoles(userId) {
    return request(`/users/${userId}/roles`);
  }

export async function updateUserRoles(userId, roleNames) {
  const result = await request(`/users/${userId}/roles`, {
    method: 'PUT',
    body: JSON.stringify({ roleNames }),
  });
  invalidateReadCache('profile');
  return result;
}

export async function getAllUsers() {
    return request('/users/all');
  }

export async function getUsersByCustomer(customerId) {
    return request(`/users/by-customer/${customerId}`);
  }

export async function getCalendarUsersForCompanyAdmin() {
    return request('/users/by-admin-companies-for-calendar');
  }

export async function getUsersForImpersonation() {
    return request('/users/for-impersonation');
  }

export const userManagementApi = {
  getUsers,
  getUserAccessOverview,
  getUserAccessMatrix,
  previewUserAccessChange,
  applyUserAccessChange,
  getUserAccessFormTypes,
  getUserAccessAssignable,
  getUserAccessHistory,
  getUserRecordActivity,
  sendUserPasswordReset,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  getAllRoles,
  getUserRoles,
  updateUserRoles,
  getAllUsers,
  getUsersByCustomer,
  getCalendarUsersForCompanyAdmin,
  getUsersForImpersonation,
};

